export default function registerWait (lf) {
  lf.register('wait', ({ RectNode, RectNodeModel, h }) => {
    class View extends RectNode {

      getLabelShape() {
        const { model } = this.props;
        const { x, y, width, height } = model;
        const style = model.getNodeStyle();
        return h(
            "svg",
            {
              x: x - width / 2 + 5,
              y: y - height / 2 + 5,
              width: 25,
              height: 25,
              viewBox: "0 0 1274 1024"
            },
            [

              h("path", {
                fill: style.stroke,
                d:
                    "M512.011264 64c-247.415808 0-448.007168 200.561664-448.007168 447.992832S264.595456 960 512.011264 960c247.414784 0 447.98464-200.577024 447.98464-448.007168S759.426048 64 512.011264 64z m0 821.325824c-206.191616 0-373.332992-167.148544-373.332992-373.332992 0-206.191616 167.141376-373.332992 373.332992-373.332992 206.191616 0 373.332992 167.141376 373.332992 373.332992 0 206.184448-167.141376 373.332992-373.332992 373.332992zM624.011264 512H512V250.674176c0-20.630528-16.741376-37.341184-37.387264-37.341184-20.62336 0-37.364736 16.710656-37.364736 37.341184v298.651648C437.248 569.940992 454.039552 586.752 474.662912 586.752h149.348352c20.608 0 37.311488-16.756736 37.311488-37.371904-0.001024-20.62336-16.703488-37.380096-37.311488-37.380096z"
              })
            ]
        );
      }
      getShape() {
        const { model } = this.props;
        const { x, y, width, height, radius, properties } = model;
        const style = model.getNodeStyle();
        return h("g", {}, [
          h("rect", {
            ...style,
            x: x - width / 2,
            y: y - height / 2,
            rx:radius,
            ry: radius,
            width,
            height
          }),
          this.getLabelShape()
        ]);
      }
    }
    class Model extends RectNodeModel {
      constructor (data, graphModel) {
        super(data, graphModel)
        this.radius = 0;
      }
    }
    return {
      view: View,
      model: Model
    }
  })
}
